import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer id="footer">
    <div className="footer-top">
      <div className="container">
        <div className="row">

          {/* Footer Info */}
          <div className="col-lg-6 col-md-6 footer-info">
            <h3>Beatior Inc</h3>
            <p>
              Our vision is to lead the charge in technological innovation and set new industry standards. We aspire to empower businesses worldwide with cutting-edge solutions, fostering growth and transforming challenges into opportunities. With a relentless commitment to quality, we aim to be the go-to partner for those seeking to harness the full potential of technology in an ever-evolving world.
            </p>
          </div>

          {/* Footer Links */}
          <div className="col-lg-3 col-md-3 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/#about">About Us</a></li>
              <li><a href="/#services">Services</a></li>
              <li><a href="/termsofservice.html">Terms of Service</a></li>
              <li><a href="/privacypolicy.html">Privacy Policy</a></li>
            </ul>
          </div>

          {/* Footer Contact */}
          <div className="col-lg-3 col-md-3 footer-contact">
            <h4>Contact Us</h4>
            <h5>US Office Address:</h5>
            <p>
              Apex, NC 27502<br />
              United States<br />
              <strong>Phone:</strong> (919) 391-8485<br />
              <strong>Email:</strong> ops@beatior.net<br />
            </p>
          </div>

        </div>
      </div>
    </div>

    {/* Footer Bottom */}
    <div className="container">
      <div className="copyright">
        &copy; Copyright <strong>Beatior Inc</strong>. All Rights Reserved
      </div>
    </div>
  </footer>
  );
}

export default Footer;
